// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Get server base URL (without /api)
const getServerBaseUrl = () => {
  if (process.env.REACT_APP_SERVER_URL) {
    return process.env.REACT_APP_SERVER_URL;
  }
  // Extract server URL from API_BASE_URL by removing /api
  return API_BASE_URL.replace('/api', '');
};

// Fetch all categories
export const getCategories = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/categories`);
    if (!response.ok) throw new Error('Failed to fetch categories');
    return await response.json();
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Error fetching categories:', error);
    }
    return [];
  }
};

// Fetch all products (with optional category filter)
export const getProducts = async (categoryId = null) => {
  try {
    const url = categoryId
      ? `${API_BASE_URL}/products?category=${categoryId}`
      : `${API_BASE_URL}/products`;
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch products');
    return await response.json();
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Error fetching products:', error);
    }
    return [];
  }
};

// Fetch single product
export const getProduct = async (productId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/products/${productId}`);
    if (!response.ok) throw new Error('Failed to fetch product');
    return await response.json();
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Error fetching product:', error);
    }
    return null;
  }
};

// Get image URL with cache busting
export const getImageUrl = (imagePath, timestamp = null) => {
  if (!imagePath) return '';
  if (imagePath.startsWith('http')) return imagePath;
  const serverUrl = getServerBaseUrl();
  const url = `${serverUrl}${imagePath}`;
  // Add cache-busting query parameter if timestamp provided
  if (timestamp) {
    return `${url}?t=${timestamp}`;
  }
  return url;
};
